import SimulationPricingsIndividualHealthForm from './components/SimulationPricingsIndividualHealthForm';
import { Loading } from '@fasstech/middle-design-system';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData';
import useGetSimulationPricingsIndividualHealthQuery from './hooks/useGetSimulationPricingsIndividualHealthQuery';
import useGetSimulationPricingsIndividualHealthGranteesQuery from './hooks/useGetSimulationPricingsIndividualHealthGranteesQuery';

const SimulationPricingsIndividualHealth = ({
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  regimeObligatoire,
  viewMode
}) => {
  const {
    getSimulationPricingsIndividualHealth,
    loading: isFetchingGetSimulationPricingsIndividualHealth
  } = useGetSimulationPricingsIndividualHealthQuery();

  const {
    getSimulationPricingsIndividualHealthGrantees,
    loading: isFetchingGetSimulationPricingsIndividualHealthGrantees
  } = useGetSimulationPricingsIndividualHealthGranteesQuery();

  const isFetching =
    isFetchingGetSimulationPricingsIndividualHealth ||
    isFetchingGetSimulationPricingsIndividualHealthGrantees;

  if (isFetching) return <Loading />;

  return (
    <SimulationPricingsIndividualHealthForm
      offer={getSimulationPricingsIndividualHealth}
      getGrantees={getSimulationPricingsIndividualHealthGrantees}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      getMiddleNumber={getMiddleNumber}
      regimeObligatoire={regimeObligatoire}
      viewMode={viewMode}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SimulationPricingsIndividualHealth);
